import {PermissionGroupedControl} from './permission-grouped-control';
import {PermissionGroupedSubControl} from './permission-grouped-sub-control';

export class PermissionGroupedControlCollection {
    private readonly items: PermissionGroupedControl[];

    private errors: string[];

    constructor(items?: PermissionGroupedControl[]) {
        this.items = !items ? [] : items;
        this.errors = [];
    }

    addItem(control: PermissionGroupedControl): void {
        this.items.push(control);
    }

    getItem(id: string): PermissionGroupedControl {
        const filteredItems = this.items.filter((item: PermissionGroupedControl) => item.id === id);

        if (filteredItems.length > 0) {
            return filteredItems[0];
        }

        return null;
    }

    addSubItem(id: string, subItem: PermissionGroupedSubControl): void {
        const filteredItems = this.items.filter((item: PermissionGroupedControl) => item.id === id);

        if (filteredItems.length > 0) {
            filteredItems[0].addSubControl(subItem);
        }
    }

    isItemExists(id: string): boolean {
        return this.items.filter((item: PermissionGroupedControl) => {
            return item.id === id;
        }).length > 0;
    }

    getItems(): PermissionGroupedControl[] {
        return this.items;
    }

    sortItems(): PermissionGroupedControl[] {
        return this.items.filter((item: PermissionGroupedControl) => {
            return item.id !== '';
        }).sort((current: PermissionGroupedControl, next: PermissionGroupedControl) => {
            return current.sortIndex - next.sortIndex;
        }).map((item: PermissionGroupedControl) => {
            item.getSubControls().sort((current: PermissionGroupedSubControl, next: PermissionGroupedSubControl) => {
                if (current.position.col !== next.position.col) {
                    return current.position.col - next.position.col;
                }

                return current.position.row - next.position.row;
            });

            return item;
        });
    }

    setError(value: string): void {
        if (this.errors.indexOf(value) < 0) {
            this.errors.push(value);
        }
    }

    setErrors(value: string[]): void {
        this.errors = value;
    }

    getErrors(): string[] {
        return this.errors;
    }

    resetErrors(): void {
        this.errors.splice(0, this.errors.length);
    }
}
